import type { TFunction } from 'i18next';
import type { OrgThemeOverlap } from '@aica/api-types/schemas';

/**
 * The names the screen gives the call categories and question subjects a
 * theme name repeats (spec §2.1) — the same labels as the Records filter and
 * the questions blocks, so the warning names what the customer sees elsewhere.
 */
export function overlapNames(
  overlaps: readonly Pick<OrgThemeOverlap, 'dimension' | 'code'>[],
  t: TFunction
): string {
  return overlaps
    .map((overlap) =>
      overlap.dimension === 'call_category'
        ? t(`records:records.callCategory.${overlap.code}`)
        : t(`dashboard:voicePage.questions.subject.${overlap.code}`)
    )
    .join(', ');
}
